import React, {ReactNode} from 'react';
import {cn} from '@bem-react/classname';
import {IClassNameProps} from '@bem-react/core';
import './DetailSettingsMenu.css'
import {ICreateObjectData} from "../../../../../common-code/interfaces/createData/ICreateObjectData";
import {ISaveUnitDetailData} from "../../../../../common-code/interfaces/saveData/ISaveUnitDetailData";
import {KitchenService} from "../../../../3d/services/KitchenService/KitchenService";
import {ISettingGroup} from "../../../../interfaces/settingData/ISettingGroup";
import {IDetailRebuildMethods} from "../../../../interfaces/settingData/IDetailRebuildMethods";
import {SETTING_GROUP_DETAIL} from "../../../../constants";
import {ISettingGroupDetail} from "../../../../interfaces/settingData/ISettingGroupDetail";
import {GOOD_TYPE_HANDLE} from "../../../../../common-code/constants";
import {ISettingGroupDetailHandle} from "../../../../interfaces/settingData/ISettingGroupDetailHandle";
import {DetailSettingsMenuHandle} from "./DetailSettingsMenuHandle";
import {Button} from "../../../components/Button";
import {Accordion} from "../../../components/Accordion";

export const cnDetailSettingsMenu = cn('DetailSettingsMenu');

export interface IDetailSettingsMenuProps extends IClassNameProps {
    detailId: number;
    unitId: number;
    data: ISaveUnitDetailData;
    service: KitchenService;
    groups: { [key: string]: ISettingGroup };
    createObjectData?: ICreateObjectData;
}

export interface IDetailSettingsMenuGroupProps extends IClassNameProps {
    data: ISaveUnitDetailData;

    onRebuildData(
        method: keyof IDetailRebuildMethods,
        detailId: number,
        parentUnit: number,
        value: any
    ): boolean;

    service: KitchenService;
}

export const DetailSettingsMenu: React.FC<IDetailSettingsMenuProps> =
    ({
         className,
         createObjectData,
         data,
         service,
         groups,
     }) => {
        const onCancelSettings = () => {
            service.hideSettingsMenu();
        }

        const onRebuildData = (
            method: keyof IDetailRebuildMethods,
            detailId: number,
            unitId: number,
            value: any
        ): boolean => {
            return service.rebuildDetailData(method, detailId, unitId, value, "detail");
        }

        const getGroupComponent = (group: ISettingGroup): ReactNode | null => {
            switch (group.id) {
                case SETTING_GROUP_DETAIL:
                    const groupData: ISettingGroupDetail = group.data as ISettingGroupDetail;
                    switch (groupData.type) {
                        case GOOD_TYPE_HANDLE:
                            const handleGroupData: ISettingGroupDetailHandle = group.data as ISettingGroupDetailHandle;
                            return <DetailSettingsMenuHandle data={data}
                                                             onRebuildData={onRebuildData}
                                                             handleData={handleGroupData}
                                                             service={service}
                                                             createUnit={createObjectData}
                            />
                        default:
                            return null;
                    }

                default:
                    return null;
            }
        }

        const groupItems: { group: ISettingGroup, children: ReactNode }[] = (Object.values(groups)).sort((a, b) => {
            return (a.sort || 0) - (b.sort || 0);
        }).map(group => {
            return {
                group: group,
                children: getGroupComponent(group)
            }
        });

        return (
            <div className={cnDetailSettingsMenu({}, [className])}>
                <Button
                    className={cnDetailSettingsMenu('CloseButton')}
                    type={'button'}
                    leftIcon={{path: 'close', width: 20, height: 20}}
                    mods={{
                        mods: {bkg: 'white', fill: 'black'},
                        hover: {mods: {fill: 'pink'}}
                    }}
                    callBack={onCancelSettings}
                />
                {!data ||
                    <div className={cnDetailSettingsMenu('Body')}>
                        <div className={cnDetailSettingsMenu('Header')}>
                        </div>
                        <div className={cnDetailSettingsMenu('Wrapper')}>
                            {groupItems.length > 0 ? groupItems.map((groupData, index) => {
                                if (!groupData.children) {
                                    return null;
                                }
                                return (
                                    <Accordion key={index}
                                               className={cnDetailSettingsMenu('Item')}
                                               text={groupData.group.title}
                                               initActive={index === 0}
                                    >
                                        {groupData.children}
                                    </Accordion>
                                );
                            }) : null}
                        </div>
                    </div>
                }
            </div>
        );
    }